module.exports = [{
      plugin: require('/home/andrew/Programming/github-repos/pork-king/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
